import { render, staticRenderFns } from "./EmployeesSettlementCancel.vue?vue&type=template&id=2b4477f7&scoped=true&"
import script from "./EmployeesSettlementCancel.vue?vue&type=script&lang=js&"
export * from "./EmployeesSettlementCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4477f7",
  null
  
)

export default component.exports